import React from 'react';
import styled from './spinner.module.css';
import { colourString } from '../../../library';
import classNames from 'classnames';
export function SpinnerIcon(_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.tone, tone = _c === void 0 ? 'primary' : _c;
    return (React.createElement("span", { className: classNames(styled.spinnerIconContainer, "kplr_spinnerIconContainer") },
        React.createElement("svg", { width: size, height: size, viewBox: "0 0 80 80" },
            React.createElement("circle", { stroke: colourString(tone), cx: "40", cy: "40", r: "32", fill: "none", strokeWidth: "7px", strokeLinejoin: "round", strokeLinecap: "round", strokeDasharray: "150 50 150 50", strokeDashoffset: "0" }))));
}
export default SpinnerIcon;
